// extracted by css-extract-rspack-plugin
export default {"readOnly":"QT3gf"};